
define('text!v3/Pages/AbilityGraph/Components/Filter/Filter.Component.html',[],function () { return '\r\n<select data-bind="options: options,\r\n\t\t\toptionsCaption:caption,\r\n\t\t\toptionsText: optionsText(),\r\n\t\t\toptionsValue: optionsValue(),\r\n\t\t\tvalue: selectedValue\r\n\t\t\t">\r\n</select>\r\n\r\n\r\n';});

